<template lang='pug'>
.vendor-invited-list(v-loading="loading")
  el-table.vendor-invited-list__table(
    :data='vendorList',
    :stripe='true',
  )
    el-table-column(
      prop='vendor_name',
      :label='$t("供应商名称")',
      align='left',
    )
    el-table-column(
      :label='$t("是否为总库供应商")',
      align='left',
    )
      template(slot-scope='scope')
        span {{ scope.row.is_total_vendor ? $t('是') : $t('否') }}
    el-table-column(
      prop='category_name',
      :label='$t("供应商服务大类")',
      align='left',
    )
    el-table-column(
      :label='$t("供应商入库状态")',
      align='left',
    )
      template(slot-scope='scope')
        span {{ scope.row.status === 1 ? $t('未激活账户') : $t('未完善信息') }}
    el-table-column(
      :label='$t("操作")',
      align='left',
    )
      template(slot-scope='scope')
        el-button(
          type='text',
          @click='edit(scope.row)'
        ) {{ $t('编辑') }}
        span.vendor-invited-list__divider |
        el-button(
          type='text',
          @click='remind(scope.row)'
        ) {{ $t('提醒入库') }}
  el-pagination.vendor-invited-list__pagination(
    layout='prev, pager, next, jumper',
    :page-size='10',
    :total='total',
    :current-page.sync='currentPage',
    @current-change='fetchCampaignList',
  )
</template>

<script>
import axios from 'axios'

export default {
  props: {
    keyword: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      vendorList: null,
      loading: false,
      currentPage: 0,
      total: null
    }
  },
  mounted () {
    this.fetchCampaignList()
  },
  methods: {
    fetchCampaignList () {
      axios
        .get('/vendor/client/getUnfinishedVendorList', {
          params: {
            keyword: this.keyword,
            page_number: this.currentPage,
            page_size: 10
          }
        })
        .then((res) => {
          this.vendorList = res.table_data
          this.total = res.total_row
        })
    },
    handleSearch () {
      this.currentPage = 1
      this.fetchCampaignList()
    },
    addNewVendor () {
    },
    edit (row) {
      this.$router.push('/vendor-management/new-vendor?id=' + row.vendor_id)
    },
    remind (row) {
      axios
        .get('/vendor/client/remind', {
          params: {
            vendor_id: row.vendor_id
          }
        })
        .then(() => {
          this.$message.success(this.$t('提醒入库成功'))
        })
    }
  }
}
</script>

<style lang='stylus'>
.vendor-invited-list__header
  display flex
  justify-content space-between

.vendor-invited-list__table
  margin 24px 32px

.vendor-invited-list__pagination
  margin-top 20px
  float right

.vendor-invited-list__divider
  margin 0 5px

.vendor-invited-list__pagination
  margin-top 20px
  float right
  .btn-next,.btn-prev
    background none !important
  .el-pager li
    background none !important
</style>
